import { toast } from 'react-toastify';
import i18n from 'core/i18n';

import updateArchiveCount from './archiveCount';
import { getUserInfo } from './auth';

let pollingIntervalId: NodeJS.Timeout | null = null;
let expiryCheckTimeout: NodeJS.Timeout | null = null;
const POLLING_INTERVAL_MS = 10000;

export const startArchivePolling = (): void => {
  stopArchivePolling();

  updateArchiveCount()
    .then(() => {
      const { hasAvailableArchives, inProgressArchivesCount, lastArchiveExpiresAt } = getUserInfo();

      if (!hasAvailableArchives) {
        return;
      }

      if (inProgressArchivesCount !== undefined && inProgressArchivesCount > 0) {
        pollingIntervalId = setInterval(async () => {
          try {
            await updateArchiveCount();

            const updated = getUserInfo();

            if (!updated.hasAvailableArchives) {
              stopArchivePolling();
              return;
            }

            if (updated.inProgressArchivesCount === 0 && updated.lastArchiveExpiresAt) {
              if (pollingIntervalId) {
                clearInterval(pollingIntervalId);
                pollingIntervalId = null;
              }

              toast.success(i18n.t('archives.archiveReady') as string, {
                position: 'top-right',
                autoClose: 5000,
              });

              const expiryTime = new Date(updated.lastArchiveExpiresAt).getTime();
              const now = Date.now();
              const timeUntilExpiry = expiryTime - now;

              if (timeUntilExpiry > 0) {
                expiryCheckTimeout = setTimeout(() => {
                  updateArchiveCount();
                  expiryCheckTimeout = null;
                }, timeUntilExpiry);
              } else {
                updateArchiveCount();
              }
            }
          } catch (error) {
            console.error('Error during archive polling:', error);
          }
        }, POLLING_INTERVAL_MS);
      } else if (inProgressArchivesCount === 0 && lastArchiveExpiresAt) {
        const expiryTime = new Date(lastArchiveExpiresAt).getTime();
        const now = Date.now();
        const timeUntilExpiry = expiryTime - now;

        if (timeUntilExpiry > 0) {
          expiryCheckTimeout = setTimeout(() => {
            updateArchiveCount();
            expiryCheckTimeout = null;
          }, timeUntilExpiry);
        } else {
          updateArchiveCount();
        }
      }
    })
    .catch(error => {
      console.error('Error during archive polling initialization:', error);
    });
};

export const stopArchivePolling = (): void => {
  if (pollingIntervalId) {
    clearInterval(pollingIntervalId);
    pollingIntervalId = null;
  }
  if (expiryCheckTimeout) {
    clearTimeout(expiryCheckTimeout);
    expiryCheckTimeout = null;
  }
};

export const isPollingActive = (): boolean => {
  return pollingIntervalId !== null;
};
